export default __webpack_public_path__ + "static/media/product-image-26.548e5cd8.jpg";